import PieChart from './src/pieChart';
import { withInstall } from '../_util/type';
export default withInstall(PieChart);
